'use client';

import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Icon from '@/components/ui/AppIcon';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Marketplace page error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 py-24 text-center">
        <Icon 
          name="ExclamationTriangleIcon" 
          size={64} 
          className="mx-auto text-destructive mb-6"
        />
        
        <h1 className="text-3xl font-bold text-foreground mb-4">
          Something went wrong!
        </h1>
        
        <p className="text-text-secondary mb-8 max-w-2xl mx-auto">
          We encountered an error while loading the marketplace. This could be due to a temporary issue. 
          Please try refreshing the page or contact support if the problem persists.
        </p>

        {process.env.NODE_ENV === 'development' && error.message && (
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4 mb-8 text-left">
            <p className="font-mono text-sm text-destructive">
              {error.message}
            </p>
          </div>
        )}
        
        <div className="flex gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-colors"
          >
            Try Again
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="px-6 py-3 bg-surface border border-border text-foreground rounded-lg font-semibold hover:bg-muted transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}